import translator from '@Components/Utilities/Translator';
import Modal from '@Components/Shared/Modals/Modal';
import AlertPreferences from '@Components/AlertPreferences/AlertPreferences';



const AlertPreferenceModal = (props) => {

    return (
        <Modal containerClassName='alert-preference-modal' onEscapeKeyClose={props.onClose}>
            <Modal.Header onClose={props.onClose} >
                <Modal.Title>{translator.translate('sandhills.tradepubwebsite.mvc.interestedinalerts')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>{translator.translate('sandhills.tradepubwebsite.mvc.interestedinalerts')}</p>
                <AlertPreferences {...props} onClose={props.onClose} IsModal={true} EventID={props.EventID} EventCategoryID={props.EventCategoryID} />
            </Modal.Body>
        </Modal>
    );
}

export default AlertPreferenceModal;